exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .ui-confirmdialog {\r\n  z-index:100000 !important\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/reincidencia-ocorrencia/reincidencia-ocorrencia.component.css
// module id = ../../../../../src/app/ocorrencias/reincidencia-ocorrencia/reincidencia-ocorrencia.component.css
// module chunks = main